/**************************************************************************
Name:         main.js
Description:  Site scripting.
Date Created: 09/27/2012 by Kyle Brickman
Modified:     12/07/2013 by Roxanne Martinez
**************************************************************************/

/* Other load events */
loadEvents.push( function( ){
	$( 'div.modal' ).click( function( evt ){
		evt.stopPropagation( );
	});

	// var signupSearchSubmit = function( evt )
	// {
	// 	//var formObj = $( 'div.curtain.signup div.modal form' );
	// 	var formObj = $( this ).closest( 'form' );
	// 	var formSection = formObj.attr( 'data-section' ); //signupCurtain or signupPortrait

	// 	var selected = formObj.find('input[type="radio"][name="organizationUUID"]:checked');
	// 	var toSubmit = formObj.serialize();
	// 	evt.preventDefault();

	// 	if( formSection == 'signupCurtain' )
	// 	{
	// 		//Modal
	// 		formObj.find( 'div.error' ).fadeOut().remove();
	// 	}
	// 	else
	// 	{
	// 		//Portrait
	// 		$('*').animate({ scrollTop: 0 }, 0);
	// 		$( 'header.portrait div.error' ).removeClass( 'active' ).css( 'height', 0 );
	// 	}

	// 	$.ajax({
	// 		url      : '/cfcs/contactDAO.cfc',
	// 		cache    : false,
	// 		dataType : 'json',
	// 		data     : toSubmit + '&method=signupStep2AJAX',
	// 		success  : function( result ){

	// 			if( jQuery.type( result.ERROR.ORGANIZATIONID ) !== 'undefined' )
	// 			{
	// 				if( jQuery.type( result.ERROR.MSG ) === 'undefined' )
	// 				{
	// 					var msgTxt = 'Please select your company to continue.';
	// 				} else
	// 				{
	// 					var msgTxt = result.ERROR.MSG;
	// 				}

	// 				if( formSection == 'signupCurtain' )
	// 				{
	// 					//Show modal error
	// 					var msg = $( '<div class = "error hidden">' + msgTxt + '</div>' );
	// 					formObj.find('legend').after( msg );
	// 					msg.animate({ 'max-height':'1000px', 'opacity':'1', 'padding-top':'5px', 'padding-bottom':'5px' },500,function(){ updateModalScroll( $( 'div.curtain.signup' ) ); });
	// 				}
	// 				else
	// 				{
	// 					//Show portrait error
	// 					$( 'header.portrait div.error div' ).html( msgTxt );
	// 					$( 'header.portrait div.error' ).addClass( 'active' ).css( 'height', $( 'header.portrait div.error div' ).height( ) + 25 + 'px' );
	// 				}

	// 			} else
	// 			{
	// 				// go to next step of sign up
	// 				//$( 'div.curtain.signup div.modal form' ).unbind( 'submit' ).attr('action','/mywusata/signupsearch/').submit();
	// 				formObj.unbind( 'submit' ).attr('action','/mywusata/signupsearch/').submit();
	// 			}
	// 		},
	// 		failure  : function( ){
	// 			window.location = '/mywusata/signupsearch/';
	// 		}
	// 	});
	// }

	var updateModalScroll = function( modalCurtainObj )
	{
		if( modalCurtainObj.find( 'div.modal' ).height() > $(window).height() )
		{
			modalCurtainObj.find( 'div.modalWrapper').addClass( 'scroll' );
		}else{
			modalCurtainObj.find( 'div.modalWrapper').removeClass( 'scroll' );
		}
	}

	// var signUpSearch = function( formObj )
	// {
	// 	var formSection = formObj.attr( 'data-section' ); //signupCurtain or signupPortrait

	// 	if( formSection == 'signupPortrait' )
	// 		$('*').animate({ scrollTop: 0 }, 0);

	// 	$.ajax({
	// 		url      : '/mywusata/signupsearch/',
	// 		cache    : false,
	// 		dataType : 'html',
	// 		success  : function( result ){
	// 			var formToInsert = $( result ).find('article.mainContent form fieldset');
	// 			if( formToInsert.html() == 'redirect' ){
	// 				window.location = '/mywusata/signupoperating/';
	// 			}else{


	// 				if( formSection == 'signupCurtain' )
	// 				{
	// 					//modal
	// 					formObj.find('fieldset.signup').remove();
	// 					formToInsert.insertAfter( formObj.find( 'legend' ) );

	// 					formObj.find( 'input[type="button"][value="Back"]' ).on( 'click', getSignupModal );
	// 					$( 'div.curtain.signup div.modal form' ).unbind( 'submit' ).on( 'submit', signupSearchSubmit );
	// 					updateModalScroll( $( 'div.curtain.signup' ) );
	// 				}
	// 				else
	// 				{
	// 					//portrait
	// 					formObj.html('');
	// 					formObj.append( formToInsert );
	// 					formObj.find( 'input[type="button"][value="Back"]' ).on( 'click', getSignupModal );
	// 					$( 'header.portrait div.signup form' ).unbind( 'submit' ).on( 'submit', signupSearchSubmit );
	// 				}

	// 			}
	// 		},
	// 		failure  : function( ){
	// 			window.location = '/mywusata/signupsearch/';
	// 		}
	// 	});
	// }

	var toggleSideNav = function( ) {
		var isActive = $( 'div.sideNav div.ctaHeader' ).hasClass( 'active' );

		if( isActive ) {
			document.cookie = 'sideNavState=open;path=/';
		} else {
			document.cookie = 'sideNavState=closed;path=/';
		}
	}

	var setCTA = function( ) {
		var cookieScope  = getCookieScope( );
		var sideNavState = 'closed';
		// var sideNavState = cookieScope.sideNavState;

		$( 'div.showHideBox div.ctaDesc' ).each( function( ) {
			var active    = $( this ).hasClass( 'active' );
			var isSideNav = $( this ).parent( ).hasClass( 'sideNav' ); 

			if( isSideNav && sideNavState == 'open' ){
				if( !active ){
					$( this ).addClass( 'active' );
					$( this ).siblings( 'div.ctaHeader' ).addClass( 'active' );
				}
				$( this ).css( 'height', 'auto' ).attr( 'data-height', $( this ).height( )).css( 'height', $( this ).height( ));
			} else if( active ) {
				$( this ).css( 'height', 'auto' ).attr( 'data-height', $( this ).height( )).css( 'height', $( this ).height( ));
			} else {
				$( this ).addClass( 'active' ).attr( 'data-height', $( this ).height( )).removeClass( 'active' );
			}
		});
	};

	$( window ).on( 'resize orientationchange', setCTA );
	setCTA( );

	var toggleCTA = function( evt )
	{
		evt.preventDefault( );

		var link   = $( this );
		var header = link.parent( 'div.ctaHeader' );
		var active = header.hasClass( 'active' );
		var ctaBox = header.next( 'div.ctaDesc' );
		var height = $(this ).parent().next( 'div.ctaDesc' ).attr( 'data-height' );
		var isSideNav = link.parent( ).parent( ).hasClass( 'sideNav' );

		if( active )
		{
			link.attr( 'title', 'Expand' );
			ctaBox.css( 'height', '' );
		}
		else
		{
			link.attr( 'title', 'Collapse' );
			ctaBox.css( 'height', height );
		}

		header.toggleClass( 'active' );
		ctaBox.toggleClass( 'active' );

		if( isSideNav ) toggleSideNav( );

	};
	$( 'div.cta.showHideBox div.ctaHeader span.chevron' ).on( 'click', toggleCTA );

	$( window ).on( 'load resize orientationchange', updateSideNav );

	var updateSideNav = function( evt )
	{
		var rightAside = $( 'html.responsive aside.rightAside' );
		var sideNav = rightAside.children('div.sideNav');
		var mainContent = $( 'html.responsive article.mainContent' );
		if( sideNav.length == 1 && rightAside.children().length == 1 && !sideNav.is( ':visible' ) ){
			rightAside.addClass( 'removed' );
			mainContent.removeClass( 'span_7_12' ).addClass( 'span_12_12' );
		}else{
			rightAside.removeClass( 'removed' );
			mainContent.removeClass( 'span_12_12' ).addClass( 'span_7_12' );
		}
	}

	var setFilterHeight = function( ) {
		$( 'div.searchFilters:not(.open):not(.exclude-height)' ).each( function( ) {
			var active = $( this ).hasClass( 'active' );

			if( active ) {
				$( this ).css( 'height', 'auto' ).attr( 'data-height', $( this ).height( )).css( 'height', $( this ).height( ));
			} else {
				$( this ).addClass( 'active' ).attr( 'data-height', $( this ).height( )).removeClass( 'active' );
			}
		});
	}

	setFilterHeight( );
	$( window ).on( 'load resize orientationchange', setFilterHeight );

	var toggleFilters = function( evt ) {
		evt.preventDefault( );

		var link    = $( this );
		var active  = link.hasClass( 'active' );
		var excludeHeight = link.hasClass( 'exclude-height' );
		var filters = $( 'div.searchFilters:not(.open)' );
		var height  = filters.attr( 'data-height' );

		if( active ) {
			link.attr( 'title', 'Expand' );
			filters.css( 'height', '' );
		}
		else if( excludeHeight ) {
			link.attr( 'title', 'Collapse' );
			filters.css( 'height', '' );
		}
		else {
			link.attr( 'title', 'Collapse' );
			filters.css( 'height', height );
		}

		link.toggleClass( 'active' );
		filters.toggleClass( 'active' );

	};

	$( 'div.mobile a.searchHeader' ).on( 'click', toggleFilters );
	
	
	if( exitPreview == 1 )		
		displayWarningBanner( 'Your Event Registration Preview has ended. Please navigate to the Event Detail page or Back Office Event Information tab to start another preview.' );


	
	//Campaign CTAs
	
	var logCampaignCTA = function( campaignCtaUUID, action, dynamicPageURL, pageUUID, buttonLink )
	{
		if( actAsUser == false )
		{
			$.ajax({
				url      : '/cfcs/campaignDAO.cfc',
				cache    : false,
				dataType : 'json',
				data     : '&method=setCtaAction' + '&campaignCtaUUID=' + campaignCtaUUID + '&action=' + action + '&dynamicPageURL=' + dynamicPageURL + '&pageUUID=' + pageUUID,
				success  : function( result ){
									
					if( action == 'click' )
						window.location.href = buttonLink;
					
				},
				failure  : function( ){
					console.log('Error with closing CTA');
				}
			});
		}
		else if( action == 'click' )
		{
			window.location.href = buttonLink;
		}
	}	
	
	var isScrolledIntoView = function(elem)
	{
	    var docViewTop = $(window).scrollTop();
	    var docViewBottom = docViewTop + $(window).height();
	
	    var elemTop = $(elem).offset().top + 100;
	    //var elemBottom = elemTop + $(elem).height();
		var elemBottom = elemTop + 200; //Ensure first 250px are visible
	
	    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
	}
	
	var logCampaignView = function(  )
	{
		if( hideSignupModal && actAsUser == false ) //Logged in
		{	
			$('.campaignCTAGroup:visible').not('.isViewed').each(function(){ 
			
				if( isScrolledIntoView($(this)) )
				{
					var action = 'view';
					var campaignCtaUUID = $(this).attr('data-uuid');
					var dynamicPageURL = $(this).attr('data-dynamicpageurl'); 
					var pageUUID = $(this).attr('data-pageuuid'); 
					var buttonLink = ''; 
					
					$(this).addClass('isViewed');
					
					logCampaignCTA( campaignCtaUUID, action, dynamicPageURL, pageUUID, buttonLink );
				}			
			
			});
		}
		
	}		
	
	$('.closeCampaignCTA, .campaignCTAButton').click(function(e){
		
		e.preventDefault();
		
		var campaignCtaUUID = $(this).attr('data-uuid');
		var dynamicPageURL = $(this).attr('data-dynamicpageurl'); 
		var pageUUID = $(this).attr('data-pageuuid'); 
		var buttonLink = $(this).attr('href'); 
		
		if( $(this).hasClass('closeCampaignCTA') )
		{
			var action = 'ignore';
		}
		else		
		{
			var action = 'click';
		}	
						
		logCampaignCTA( campaignCtaUUID, action, dynamicPageURL, pageUUID, buttonLink );
		
		if( action == 'ignore' )
		{
			
			$('.campaignCTACount').each(function(){ 
				var newTotal = Number( $(this).text() ) - 1;
				
				if( newTotal != 0 )			
					$(this).text( newTotal );
				
				if( newTotal == 1 )
				{
					$('.previousCampaignCTA').addClass('notVisible');
					$('.nextCampaignCTA').addClass('notVisible');
					$('.campaignCTAMessages').addClass('notVisible');
				}
			});
						
			$('.campaignCTAGroup[data-uuid=' + campaignCtaUUID + ']').addClass('closed').removeClass('active').fadeOut(400, function( ){ 
				$('.campaignCTAGroup:not(.closed)').first().fadeIn().removeClass('hideCampaignCTA').addClass('active');
				
				$('.campaignCTAGroup:not(.closed)').each(function( index ) {
					$( this ).find( ".campaignCTACurrent" ).text( index + 1 );
				});
				
				logCampaignView();
			});

		}
		
	});	
	
	var setCampaignCtaDirection = function( )
	{
		
		if( $(window).width() < 768 )
		{
			
			$('.campaignCTAGroup.useHorizontal.horizontal').each(function(){ 
				
				$(this).removeClass('horizontal').addClass('vertical');		
			});
		}
		else
		{
			$('.campaignCTAGroup.useHorizontal.vertical').each(function(){ 
				$(this).removeClass('vertical').addClass('horizontal');		
			});
		}
	}	
	
	var onStopScroll = function (callback) {
	
		var isScrolling;
		window.addEventListener('scroll', function (event) {
			window.clearTimeout(isScrolling);
			isScrolling = setTimeout(function() {
				callback();
			}, 55);
		}, false);
	
	};	
	
	if( showCampaigns == true )
	{
		if( actAsUser == false )
		{
			setTimeout( logCampaignView(), 200 );
			onStopScroll( logCampaignView );
		}
		
		$( window ).on( 'resize orientationchange', setCampaignCtaDirection );
		setCampaignCtaDirection();
	}
			
	$('.previousCampaignCTA, .nextCampaignCTA').click(function(){
		
		if( $(this).hasClass('nextCampaignCTA') )
			var direction = 'forward';
		else
			var direction = 'back';	
			
		var ctaIndex = $('.campaignCTAGroup:not(.closed)').index( $('.campaignCTAGroup.active') );
		var totalCTAs = Number( $('.campaignCTACount').first().text() ) - 1;
				
		var newIndex = 0;
		
		if( direction ==  'forward' && ctaIndex < totalCTAs )
			newIndex = ctaIndex + 1;
		else if( direction ==  'back' && ctaIndex > 0 ) 	
			newIndex = ctaIndex - 1;
		else if( direction ==  'back' )	
			newIndex = totalCTAs;
					
		$('.campaignCTAGroup.active').removeClass('active').fadeOut(400, function( ){ 
			$('.campaignCTAGroup:not(.closed)').eq(newIndex).fadeIn().removeClass('hideCampaignCTA').addClass('active');
			
			logCampaignView();
		});
		
	});	

	if( hideSignupModal )
	{
		$(".brandedMenu .tabs a").click(function(event) {
			event.preventDefault();
			var control = $(this);

			var targetID = control.data('target');
			var target = $('.brandedMenu .tabContents[data-tab="' + targetID + '"]');
			var targetControl = $('.brandedMenu .tabs a[data-target="' + targetID + '"]');

			if (control.hasClass('open')) {
				targetControl.toggleClass('open');
				target.toggleClass('open');
			}
			else {
				var openControls = $(".brandedMenu .tabs a.open");
				var openTabContents = $('.brandedMenu .tabContents.open');

				openControls.toggleClass('open');
				openTabContents.toggleClass('open');
				targetControl.toggleClass('open');
				target.toggleClass('open');
			}

			return false;
		});
	}

//End loadEvents
});

/* Google Analytics event tracking */
var trackGaEvent = function(eventAction, urlAction, url) {
	// Standard callback
	function analyticsCallback() {
		if(urlAction != undefined && url != undefined) {
			if(urlAction == 'openWindow') window.open( url );
			else window.location = url;
		}
	}

	$.ajax({
		url      : '/cfcs/pageGW.cfc',
		data     : {
			method : 'getGaEventTrackingAJAX'
		},
		cache    : false,
		dataType : 'json',
		success  : function( result )
		{
			if(result.TRACK) {
				
				/*ga('send', {
					'hitType': 'event',
					'eventCategory': result.eventCategory,
					'eventAction': eventAction,
					'eventLabel': result.eventLabel,
					'eventValue': result.eventValue,
					'hitCallback': analyticsCallback
				});*/

				gtag('event', result.eventCategory, {
					'event_action': eventAction,
					'event_label': result.eventLabel,
					'value': result.eventValue,
					'event_callback': analyticsCallback
					});

			} else {
				analyticsCallback();
			}

			if (result.SHOWAVIBE) {
				console.log("****** A-VIBE Only -- Google Analytics event tracking code ******");
				console.log("gtag('event', result.eventCategory, {'event_action': eventAction,'event_label': result.eventLabel,'value': result.eventValue,'event_callback': analyticsCallback});");
			}
		},
		error : function( jqXHR, status, thrown )
		{
			$.ajax({
				url  : '/cfcs/pageDAO.cfc',
				data : {
					method : 'gaEventTrackingErrorAJAX',
					status : status,
					thrown : thrown
				},
				cache    : false,
				dataType : 'json'
			});

			if(urlAction != undefined && url != undefined) {
				if(urlAction == 'openWindow') window.open( url );
				else window.location = url;
			}
		}
	});	
}